import { isEmpty, times } from "lodash";
import React, { useContext } from "react";
import { useEffect } from "react";

import BetSlipContext from "../../context/BetSlipContext";

const BackandLayNew = ({
  back,
  lay,
  item,
  details,
  slipObj,

  betType,
  betmode,
  amountRange,
}) => {
  let { betSelectionObj } = useContext(BetSlipContext);

  const backOdd = () => {
    if (betType === "bookmaker") {
      if (back[0]?.ms == 1) {
        return back[0]?.rt;
      } else {
        return null;
      }
    } else {
      return back[0]?.rt;
    }
  };
  const backOddSpan = () => {
    if (betType === "bookmaker") {
      // if (back[0]?.ms == 1) {
      //   return back[0]?.bv;
      // } else {
      return null;
      // }
    } else {
      return back[0]?.bv;
    }
  };

  const layOdd = () => {
    if (betType === "bookmaker") {
      if (lay[0]?.ms == 1) {
        return lay[0]?.rt;
      } else {
        return null;
      }
    } else {
      return lay[0]?.rt;
    }
  };
  const layOddSpan = () => {
    if (betType === "bookmaker") {
      return null;
    } else {
      return lay[0]?.bv;
    }
  };

  return (
    <>
      <dd
        id="back_1"
        className={
          back[0]?.rt == undefined ||
          back[0]?.rt == 0 ||
          details?.sport_setting?.status == "inActive"
            ? "single-disabled"
            : back[0]?.rt > amountRange?.oddsLimit
            ? "single-disabled"
            : ""
        }
      >
        <a
          style={{ padding: "10px", fontSize: "14px" }}
          name={back[0]?.bv}
          title={back[0]?.rt}
          id={"back_odds_" + item?.SelectionId || item?.SelectionId}
          className={
            slipObj?.teamName ==
              (betType == "betFair" ? item?.RunnerName : item?.runnerName) &&
            betSelectionObj?.layorback == "back" &&
            betSelectionObj.betType == betType &&
            betSelectionObj?.priceToogle
              ? `back-1 select ${
                  Number(
                    document.getElementById(
                      "back_odds_" + item?.SelectionId || item?.SelectionId
                    )?.name
                  ) !== back[0]?.bv && "spark"
                } ${
                  Number(
                    document.getElementById(
                      "back_odds_" + item?.SelectionId || item?.SelectionId
                    )?.title
                  ) !== back[0]?.rt && "spark"
                }`
              : `back-1 ${
                  Number(
                    document.getElementById(
                      "back_odds_" + item?.SelectionId || item?.SelectionId
                    )?.name
                  ) !== back[0]?.bv && "spark"
                } ${
                  Number(
                    document.getElementById(
                      "back_odds_" + item?.SelectionId || item?.SelectionId
                    )?.title
                  ) !== back[0]?.rt && "spark"
                }`
          }
          href="javascript:void(0)"
        >
          {backOdd()}
        </a>
      </dd>
      <dd
        id="lay_1"
        className={
          lay[0]?.rt == undefined ||
          lay[0]?.rt == 0 ||
          details?.sport_setting?.status == "inActive"
            ? "single-disabled"
            : lay[0]?.rt > amountRange?.oddsLimit
            ? "single-disabled"
            : ""
        }
        style={
          lay?.length === 0 ||
          betmode == "off" ||
          details?.sport_setting?.status == "inActive"
            ? { cursor: "not-allowed" }
            : { cursor: "pointer" }
        }
      >
        <a
            style={{ padding: "10px", fontSize: "14px" }}
          id={"lay_odds_" + item?.SelectionId || item?.SelectionId}
          name={lay[0]?.bv}
          title={lay[0]?.rt}
          className={
            slipObj?.teamName ==
              (betType == "betFair" ? item?.RunnerName : item?.runnerName) &&
            betSelectionObj?.layorback == "lay" &&
            betSelectionObj.betType == betType &&
            betSelectionObj?.priceToogle
              ? `lay-1 select ${
                  Number(
                    document.getElementById(
                      "lay_odds_" + item?.SelectionId || item?.SelectionId
                    )?.name
                  ) !== lay[0]?.bv && "spark"
                } ${
                  Number(
                    document.getElementById(
                      "lay_odds_" + item?.SelectionId || item?.SelectionId
                    )?.title
                  ) !== lay[0]?.rt && "spark"
                }`
              : `lay-1 ${
                  Number(
                    document.getElementById(
                      "lay_odds_" + item?.SelectionId || item?.SelectionId
                    )?.name
                  ) !== lay[0]?.bv && "spark"
                } ${
                  Number(
                    document.getElementById(
                      "lay_odds_" + item?.SelectionId || item?.SelectionId
                    )?.title
                  ) !== lay[0]?.rt && "spark"
                }`
          }
          href="javascript:void(0)"
        >
          {layOdd()}
        </a>
      </dd>
    </>
  );
};

export default BackandLayNew;
